<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/iDAZGU/tc-custom/9781635762228.jpg?1728851738585" alt="This image is the cover for the book Flights of Angels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Flights of Angels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>The National Book Award–winning Southern authorhumorously explores themes of marriage, love, gender, race, age, and more in eighteen short stories.</b><br/><br/> Unplanned pregnancy, born-again Christianity, and strained sibling relationships are explored through precocious sixteen-year-old narrator Aurora Harris in “The Triumph of Reason,” “Have a Wonderful Nice Walk,” and “Witness to the Crucifixion.” Crystal and her housekeeper Traceleen feel the straining of family ties and the force of chauvinism in “Miss Crystal Confronts the Past” and “A Sordid Tale.”<br/><br/> Hope, laughter, and love balance tragedy in this must-read for die-hard Gilchrist fans.<br/><br/><b>“A convincing evocation of the changing South. The new reality, as depicted here, includes the waning of racism, the sexual revolution and the growth of feminism. . . . One reads this collection entertained by her distinctive prose, beguiled by her vivid characters and buoyed by the insistent touches of humor and hope that she brings to her vision of chaotic lives.” —<i>Publishers Weekly</i></b><br/><br/><b>“Her fiction is so delectably yarny. It’s back-porch material. . . . Her dual senses of comedy and poignancy continue in close partnership; the typical laugh-and-cry reaction to a Gilchrist story is both anticipated and realized in every piece gathered here.” —<i>Booklist</i></b><br/><br/><b>“Gilchrist has always excelled in delineating smart, sexy, crazy people struggling to come to terms with a legacy of beloved, bewildering progenitors.” —<i>Kirkus Reviews</i></b></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ellen Gilchrist
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Diversion Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?37b984eb